import {
  NotificationOption,
  NotificationOptionType,
  NotificationsViewModel,
} from '../../../../store/slices/notifications';

const prepareNotificationsList = (
  notifications: NotificationsViewModel
): NotificationOption[] =>
  Object.values(notifications).map(notification => ({
    value: notification.id,
    icon: notification.icon,
    label: notification.label,
    disabled: notification.disabled,
    type: NotificationOptionType.VALUE,
  }));

export default prepareNotificationsList;
